import React, { useState } from 'react';
import axios from 'axios';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { LinkSmall } from '@styled';

import useIcscTracking from '@tracking/useIcscTracking';
import styled from 'styled-components';
import fonts from '@general/fonts';

const Description = styled.p`
    font-family: ${fonts.sans};
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 21px;
    margin: 0;
`;

const MemberEmail = ({ id }) => {
    const [email, setEmail] = useState();
    const [lookupError, setLookupError] = useState(false);
    const [xid, setXid] = useState($('input[name=lookup_token]').val());
    const [isLoading, setIsLoading] = useState(false);
    const { trackEvent } = useIcscTracking();

    const fetchEmail = async () => {
        if (isLoading) {
            return;
        }

        setIsLoading(true);

        const { data } = await axios.post('/api/emaillookup', {
            member_id: id,
            XID: $('input[name=lookup_token]').val(),
        });
        if (data.member_id) {
            setEmail(data.member_id);
            trackEvent({
                click: {
                    type: 'conversion',
                    target: 'member_email_reveal',
                    value: `Revealed ${data.member_id}/'s email`,
                },
            });
        }

        if (data.error) {
            setLookupError(data.error);
        }

        if (data.XID) {
            $('input[name=lookup_token]').val(data.XID);
            setXid(data.XID);
        }

        setIsLoading(false);
    };

    if (lookupError) {
        return (
            <Description className="mb-1rem">
                {lookupError}
            </Description>
        );
    }

    if (!email) {
        return (
            <LinkSmall
                className={classnames({
                    'cursor-wait': isLoading,
                })}
                href="#"
                onClick={e => {
                    e.preventDefault();
                    fetchEmail();
                }}
            >
                Click here to display email
            </LinkSmall>
        );
    }

    return <LinkSmall href={`mailto:${email}`}>{email}</LinkSmall>;
};

MemberEmail.propTypes = {
    id: PropTypes.number.isRequired,
};

export default MemberEmail;
